module.exports = __webpack_public_path__ + "static/img/shanghaishehuikexueyuan.344ebd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/shanghaishehuikexueyuan.jpg
// module id = Qnn7
// module chunks = 36